module.exports = __webpack_public_path__ + "img/TECNOLOGIA-BALENO-1.1102ceac.jpg";